var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7072 4.29375L17.7072 0.293751C17.3167 -0.0966303 16.6837 -0.0966303 16.2932 0.293751L13.5002 3.08675L18.9142 8.50075L21.7072 5.70775C22.0976 5.31725 22.0976 4.68425 21.7072 4.29375Z",
    fill: "#0679C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70721 19.7078L17.5002 9.91475L12.0862 4.50075L2.29321 14.2938C2.18363 14.4036 2.10112 14.5375 2.05221 14.6848L0.0522137 20.6848C0.0177937 20.7866 0.00022893 20.8933 0.000213667 21.0008C0.000457793 21.322 0.155041 21.6236 0.415714 21.8114C0.676388 21.9992 1.01141 22.0503 1.31621 21.9488L7.31621 19.9488C7.46348 19.8998 7.59734 19.8173 7.70721 19.7078Z",
    fill: "#0679C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePen);
export default __webpack_public_path__ + "static/media/blue_pen.6bed8aae59f2ea0fc3fadf618dc8c6cc.svg";
export { ForwardRef as ReactComponent };